export const wltp = (fuel_consumption = null, co_two_emissions = null, engine = null, isB2B = false) => {
    let wltp = ''
    const getNumber = (num) => {
        if (isB2B) {
            if (num === 4) return 1
        }
        return num
    }

    if (fuel_consumption !== null && fuel_consumption !== '') {
        const unit = engine === 'ev' ? 'kWh' : 'l'
        wltp += `${fuel_consumption} ${unit}/100 km (WLTP)(${getNumber(4)})`
    }
    if (co_two_emissions !== null && co_two_emissions !== '') {
        if (wltp !== '') wltp += ' '
        wltp += `${co_two_emissions} g CO2/km (WLTP)(${getNumber(4)})`
    }
    return wltp
}